import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useContent = () =>
  useQuery({ queryKey: ["content"], queryFn: async () => (await api.get("/content")).data, staleTime: 5 * 60_000 });

const isId = (src) => src && !src.startsWith("/") && !src.startsWith("http");

export const imgUrl = (src, w = 800, extra = "") => {
  if (!src) return "";
  if (src.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${src}`;
  if (!isId(src)) return src;
  return `https://images.unsplash.com/photo-${src}?auto=format&fit=crop&w=${w}&q=80${extra}`;
};

export const imgSet = (src, extra = "") =>
  isId(src) ? [480, 800, 1200].map((w) => `${imgUrl(src, w, extra)} ${w}w`).join(", ") : undefined;

export const csv = (s) => (s || "").split(",").map((x) => x.trim().toLowerCase()).filter(Boolean);

export const servicesFor = (look, categories) => {
  const cats = csv(look.categories);
  const words = csv(look.match_words);
  const re = words.length ? new RegExp(`\\b(${words.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|")})(?![a-z])`, "i") : null;
  return categories
    .map((c) => ({ ...c, items: cats.includes(c.id) ? c.items : re ? c.items.filter((s) => re.test(s.name)) : [] }))
    .filter((c) => c.items.length)
    .sort((a, b) => (cats.indexOf(a.id) + 1 || 99) - (cats.indexOf(b.id) + 1 || 99));
};
